import UserList from "../View/User/UserList/UserList";
import CreateUser from "../View/User/CreateUser/CreateUser";
import CreateProject from "../View/Project/CreateProject/CreateProject";
import ProjectList from "../View/Project/ProjectList/ProjectList";
import AccountSetting from "../View/AccountSetting/AccountSetting";
import CompanyList from "../View/Company/CompanyList/CompanyList";
import CreateCompany from "../View/Company/CreateCompany/CreateCompany";
import Report from "../View/Report/Report";
import CreateAdmin from "../View/Admin/CreateAdmin/CreateAdmin";
import AdminList from "../View/Admin/AdminList/AdminList";
import Dashboard from "../View/Dashboard/Dashboard";
import AttendanceReport from "../View/Progress/AttendanceReport"
import UserAttendanceList from "../View/User/UserList/UserAttendanceList"
import UserTimeReport from "../View/Report/UserTimeReport"
import SingleReport from "../View/Report/SingleReport"
const AdminRoute = [
  {
    path: "/dashboard",
    component: <Dashboard /> ,
  },
      {
        path: "/createuser",
        component: <CreateUser /> ,
      },
      {
        path: "/userlist",   
        component: <UserList /> ,
      },
      {
        path: "/user-attendance-list",   
        component: <UserAttendanceList /> ,
      },
      // {
      //   path: "/createadmin",
      //   component: <CreateAdmin /> ,
      // },
      // {
      //   path: "/adminlist",   
      //   component: <AdminList /> ,
      // },
      {
        path: "/createproject",
        component: <CreateProject /> ,
      },
      {
        path: "/projectlist",   
        component: <ProjectList /> ,
      }, 
      {
        path: "/report",   
         component: <Report /> ,
      },
      {
        path: "/single-report",   
         component: <SingleReport /> ,
      },
      {
        path: "/account",   
         component: <AccountSetting /> ,
      },
      {
        path: "/attendance-report",   
         component: <AttendanceReport /> ,
      },
      {
        path: "/timereport",   
         component: <UserTimeReport /> ,
      },
    
 
];

export default AdminRoute;
